import { useEffect } from "react";

/**
 * Custom hook that triggers a callback when a click occurs outside the referenced element.
 * @param {React.RefObject} ref - Ref attached to the element to monitor
 * @param {Function} callback - Function to call when a click outside is detected
 */
const useClickOutside = (ref, callback) => {
  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback(event);
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [ref, callback]);
};

export default useClickOutside;
